import { useState, useEffect, useContext, useMemo } from "react";
import { Context } from '../../../components/Context';
import { __echoText, ButtonSpinner, validateForm, initialFormState, ConfirmationModal, noImageHandle, cleanEditorContent, showAlertMsg, decodeHTMLEntities, ExpandView } from "../../../components/CommonMethod";
import { DataTable } from "../../../components/DataTable";
import { fetchData, GET_TESTIMONIALS, TESTIMONIALS_CHANGE_STATUS, DELETE_TESTIMONIALS, UPSERT_TESTIMONIALS, ASSET_ENDPOINT, SETTING_PAGE } from "../../../components/Service";
import { format } from 'date-fns';
import { now, startCase } from 'lodash';
import ImageDropdown from "../../../components/ImageDropdown";
import { CKEditor } from "ckeditor4-react";
import ReactHtmlParser from "react-html-parser"

const TestimonialList = ({ page = '', className = '' }) => {
    const [context,] = useContext(Context);
    const [refresh, setRefresh] = useState(true);
    const [imageData, setImageData] = useState([]);
    const [tinyloader, setTinyloader] = useState(false);
    const [resetImage, setResetImage] = useState(null);
    const [testimonialData, setTestimonialData] = useState(null);
    const [deleteTestimonialId, setDeleteTestimonialId] = useState(0);
    const [ckeditorInstance, setCkeditorInstance] = useState(null);
    const PAGE = useMemo(() => {
        if (page) {
            if (page === 'shop') return ['shop', 'shop-details'];
            else return [page];
        }
        return ['home', 'about'];
        // return ['unknown', 'home', 'about', 'shop', 'shop-details', 'checkout'];
    }, [page])

    const testimonials = {
        id: 'testimonials',
        fetchurl: `${GET_TESTIMONIALS}`,
        query_string: `page=${(page === 'shop') ? 'shop,shop-details' : page}`,
        columns: [
            { data: 'page', name: 'page', title: 'TESTIMONIAL FOR PAGE', visible: (context?.auth?.user_type === '1' || context?.auth?.user_type === '3') },
            { data: 'name', name: 'name', title: 'NAME' },
            { data: 'image', name: 'image', title: 'IMAGES', sorting: false, searching: false },
            { data: 'description', name: 'description', title: 'DESCRIPTION' },
            { data: 'status', name: 'status', title: 'STATUS' },
            { data: 'created_at', name: 'created_at', title: 'DATE CREATION' },
            { data: 'created_by', name: 'created_by', title: 'CREATED BY', sorting: false, searching: false, visible: (context?.auth?.user_type === '1' || context?.auth?.user_type === '3') },
            { data: 'action', name: 'action', title: 'Action', sorting: false, searching: false }
        ]
    }

    useEffect(() => {
        fetchData(SETTING_PAGE, 'GET', '', true, false, (res) => {
            if (res.records) {
                setImageData(JSON.parse(res.records.value));
            }
        });
    }, [])

    const updateStatus = (id) => {
        fetchData(`${TESTIMONIALS_CHANGE_STATUS}/${id}`, 'POST', {}, true, false, (res) => {
            setRefresh(now())
        });
    }

    const deleteTestimonial = () => {
        fetchData(`${DELETE_TESTIMONIALS}/${deleteTestimonialId}`, 'POST', {}, true, false, (res) => {
            document.querySelector('#deletesection_modal [data-bs-dismiss="modal"]').click()
            if (res.success) {
                setRefresh(now())
            }
        });
    }

    const resetTestimonialAction = () => {
        initialFormState('upsertTestimonialForm');
        setTestimonialData(null);
        ckeditorInstance?.setData('');
        setResetImage(now());
    }

    const editTestimonialAction = (data) => {
        initialFormState('upsertTestimonialForm');
        const parseData = ReactHtmlParser(data.description);
        setTestimonialData(data);
        ckeditorInstance?.setData(parseData?.[0] || '');
    }

    const upsertTestimonial = (e) => {
        var formdata = new FormData(document.getElementById('upsertTestimonialForm'));
        const isValidate = validateForm(e, "upsertTestimonialForm");

        if (ckeditorInstance && cleanEditorContent(ckeditorInstance.getData()) < 10) {
            showAlertMsg({ error: 'The description must be atleast 10 Character.' });
            return;
        }

        if (!isValidate) return;

        formdata.append('description', ckeditorInstance.getData());
        setTinyloader(true);
        fetchData(`${UPSERT_TESTIMONIALS}${testimonialData ? '/' + testimonialData.id : ''}`, 'POST', formdata, true, true, (res) => {
            setTinyloader(false);
            if (res.success) {
                setRefresh(now)
                document.querySelector('#upsertTestimonial [data-bs-dismiss="modal"]').click()
            }
        })
    }

    const pageFilter = (e, setDt) => {
        setDt(prevState => ({
            ...prevState,
            filter: e.target.value
        }))
    }

    return (
        <>
            <div className={`row ${className}`}>
                <div className="col-sm-12">
                    {(page || (context && ['2'].includes(context?.auth?.user_type))) && <>
                        <div className="row g-2 align-items-center">
                            <div className="col-lg-6 col-sm mb-3 col-6">
                                <h1 className="h3 text-dim">Testimonials</h1>
                            </div>
                            <div className="col-lg-6 mb-3 col-6">
                                <button type="button" className="btn btn-green btn-lg px-3 float-end" data-bs-toggle="modal" data-bs-target="#upsertTestimonial" title="Add">
                                    + Add Testimonial
                                </button>
                            </div>
                        </div>
                    </>}
                    <div className="tab-content pt-4">
                        <div className="tab-pane active" id="studentsBox" role="tabpanel" tabIndex="0">
                            <DataTable
                                execute={refresh}
                                dt={testimonials}
                                outerbutton={(records, setDt) => page ? <></> : <>
                                    <select className="form-control form-select width_selecto border" onChange={(e) => pageFilter(e, setDt)}>
                                        <option value="">All</option>
                                        {PAGE.map((item, i) => <option value={item} key={i}>{startCase(item)}</option>)}
                                    </select>
                                </>}
                                edit_column={{
                                    page: (records) => __echoText(`${startCase(records.page)}`),
                                    image: (records) =>
                                        <div className="ratio ratio-1x1 mmw-56 rounded-3 shadow-md overflow-hidden" >
                                            <img src={ASSET_ENDPOINT + records.image} alt={records.title} onError={noImageHandle} />
                                        </div>,
                                    description: (records) => <ExpandView string={decodeHTMLEntities(records.description)} length={100} more html />,
                                    status: (records) => (context && ['2', '4', '5'].includes(context?.auth?.user_type)) ? <span className={records.status === 'active' ? 'text-success' : 'text-danger'}>{records.status === 'active' ? 'Active' : 'Inactive'}</span> : <>
                                        <button type="button" className={`px-3 btn-sm m-3 btn btn-${records.status === 'active' ? 'green' : 'danger'}`} onClick={() => updateStatus(records.id)}>
                                            {records.status === 'active' ? 'Active' : 'Inactive'}
                                        </button>
                                    </>,
                                    created_at: (records) => __echoText(`${format(new Date(records.created_at), 'MM/dd/yyyy')}`),
                                    created_by: (records) =>
                                        <div className="">
                                            <div className="d-flex"><span>Name:</span><span className="text-info ms-2">{records?.user?.first_name} {records?.user?.last_name}</span></div>
                                            <div className="d-flex"><span>Email:</span><span className="text-info ms-2">{records?.user?.email}</span></div>
                                            <div className="d-flex"><span>Role:</span><span className="text-info ms-2">{records?.user?.roleName}</span></div>
                                        </div>,
                                    action: (records) =>
                                        <div className="d-flex">
                                            <button onClick={(e) => editTestimonialAction(records)} type="button" className="btn btn-sm text-black" data-bs-toggle="modal" data-bs-target="#upsertTestimonial" title="Edit">
                                                <svg className="icon fs-5" role="img"><use href="#icon_pencil" /></svg>
                                            </button>
                                            <button onClick={() => setDeleteTestimonialId(records.id)} className="btn btn-sm text-danger btn-lg border border-1 border-danger" title="Delete" data-bs-toggle="modal" data-bs-target="#deletesection_modal">
                                                <svg className="icon fs-5" role="img"><use href="#icon_delete" /></svg>
                                            </button>
                                        </div>
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="upsertTestimonial" data-bs-backdrop="static" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content border border-4 border-primary rounded-4">
                        <form action="#" method="post" className="needs-validation" id="upsertTestimonialForm" noValidate >
                            <div className="modal-body">
                                <h5 className="modal-title mb-4 fw-bold" >{testimonialData ? 'Edit' : 'Add'} Testimonials</h5>
                                {(context?.auth?.user_type === '1' || context?.auth?.user_type === '3') && <>
                                    <div className="mt-3 mb-1">
                                        <div className="form-floating">
                                            <select className="form-select form-select-md" name="page" id="page" required>
                                                {PAGE.map((item, i) => <option selected={testimonialData?.page === item} value={item} key={i}>{startCase(item)}</option>)}
                                            </select>
                                            <label>For Page <span className="text-danger">*</span></label>
                                        </div>
                                    </div>
                                </>}
                                <div className="mt-3 mb-3">
                                    <div className="form-floating">
                                        <input type="text" id="name" name="name" className="form-control form-control-md" placeholder="Enter name" defaultValue={testimonialData?.name} required />
                                        <div className="invalid-feedback">Please Enter Full Name.</div>
                                        <label>Full Name<span className="text-danger" id="required_attr">*</span></label>
                                    </div>
                                </div>
                                <div className="mb-1 mt-3">
                                    <div className="form-floating">
                                        <div className="fs-12 text-dim fw-bold mt-14 ps-3">Description</div>
                                        <ImageDropdown value={testimonialData?.image} imageList={imageData} name="image" id="image" reset={resetImage} />
                                    </div>
                                </div>

                                <div className="mb-1 mt-3">
                                    <div className="form-floating">
                                        <div className="fs-12 text-dim fw-bold mt-14 ps-3">Choose Image</div>
                                        <CKEditor onInstanceReady={(event) => setCkeditorInstance(event.editor)} editorUrl='../ckeditor/ckeditor.js' />
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer border-0">
                                <button type="button" className="btn btn-danger order-sm-1" onClick={resetTestimonialAction} data-bs-dismiss="modal" aria-label="Close">Close</button>
                                <button type="button" className="btn btn-theme-primary order-sm-1" onClick={upsertTestimonial} disabled={tinyloader}>
                                    <ButtonSpinner load={tinyloader} btnName="Save Changes" />
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <ConfirmationModal msg={`Delete ?`} method={deleteTestimonial} />
        </>
    )
}
export default TestimonialList;